import styled from 'styled-components';

export const Steps = styled.ul`
    position: relative;
    left: 0;
    top: 0;
    right: 0;
    padding-left: 0 !important;
    display: flex;
    white-space: nowrap;
    align-items: center;
    list-style: none;
    margin: 0;
    justify-content: center;
    z-index: 2;
    counter-reset: step-counter;
`;

export const Step = styled.li<{ $active?: boolean }>`
    counter-increment: step-counter;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0 4px;
    font-size: 11px;
    font-weight: ${({ $active }) => ($active ? '700' : '400')};
    color: ${({ $active }) => ($active ? '#263238' : '#90a4ae')};
    text-transform: uppercase;
    letter-spacing: 0.8px;
    font-family: ${(props) => props.theme.app.font};
    position: relative;

    &::before {
        content: counter(step-counter);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        min-width: 22px;
        border-radius: 50%;
        font-size: 11px;
        font-weight: 600;
        line-height: 1;
        background: ${({ $active, theme }) => ($active ? theme.app.primary : '#eceff1')};
        color: ${({ $active }) => ($active ? '#fff' : '#90a4ae')};
    }

    &:not(:first-child) {
        margin-left: 4px;
    }

    &:not(:first-child)::after {
        content: '';
        position: absolute;
        right: 100%;
        top: 50%;
        width: 20px;
        height: 1px;
        background: #cfd8dc;
        margin-right: 4px;
    }

    &:not(:first-child) {
        margin-left: 28px;
    }
`;
